import { useRef, useState } from 'react';
import Dialog from '../components/Dialog/Dialog';

export default function useDialog() {
    const [dialogState, setDialogState] = useState(null);
    const resolveRef = useRef(null);

    const openDialog = (type, message, defaultValue = '') =>
        new Promise(resolve => {
            resolveRef.current = resolve;
            setDialogState({ type, message, defaultValue });
        });

    const dismiss = (value) => {
        resolveRef.current?.(value);
        resolveRef.current = null;
        setDialogState(null);
    };

    return {
        confirm: (message) => openDialog('confirm', message),
        alert: (message) => openDialog('alert', message),
        prompt: (message, defaultValue = '') => openDialog('prompt', message, defaultValue),
        DialogUI: dialogState ? <Dialog {...dialogState} onDismiss={dismiss} /> : null,
    };
}